import { CONSTANTS } from '../constants/constants.jsx';

const VERIFICATION_FIELD_NAMES = {
  UPPERCASE: 'VERIFICATION',
  LOWERCASE: 'verification'
};

export const isVerificationMethodEnabled = (value, enabledVerificationMethods) => {
  if (!enabledVerificationMethods) return true;

  const [HEURISTIC, CRYPTOGRAPHIC_HASH, PACKAGE_MANAGER, FUNCTION_HASHING, SYMBOL_INDEX, USER_MODIFIED] =
    CONSTANTS.TABLE.SBOM_TABLE.VERIFICATION_FILTER_VALUES.map(item => item.value);

  switch (value) {
    case HEURISTIC:
      return enabledVerificationMethods.heuristic;
    case CRYPTOGRAPHIC_HASH:
      return enabledVerificationMethods.cryptographicHash;
    case PACKAGE_MANAGER:
      return enabledVerificationMethods.packageManager;
    case FUNCTION_HASHING:
      return enabledVerificationMethods.functionHashing;
    case SYMBOL_INDEX:
      return enabledVerificationMethods.symbolIndex;
    case USER_MODIFIED:
      return true;
    default:
      return false;
  }
};

const isVerificationFilter = filter => {
  return (filter?.fieldName === VERIFICATION_FIELD_NAMES.UPPERCASE || filter?.columnName === VERIFICATION_FIELD_NAMES.LOWERCASE) && filter?.value;
};

const validateArrayValues = (values, enabledVerificationMethods) => {
  const validValues = values.filter(value => isVerificationMethodEnabled(value, enabledVerificationMethods));
  return validValues.length === 0 ? null : validValues;
};

const validateConcatenatedValues = (value, enabledVerificationMethods) => {
  const individualValues = value.split('&');
  const validIndividualValues = individualValues.filter(val => isVerificationMethodEnabled(val, enabledVerificationMethods));

  if (validIndividualValues.length === 0) {
    return null;
  } else if (validIndividualValues.length === individualValues.length) {
    return value;
  } else {
    return validIndividualValues.join('&');
  }
};

const validateSingleValue = (value, enabledVerificationMethods) => {
  return isVerificationMethodEnabled(value, enabledVerificationMethods) ? value : null;
};

export const validateVerificationFilters = (filters, enabledVerificationMethods) => {
  if (!enabledVerificationMethods) return filters;

  return filters
    ?.map(filter => {
      if (!isVerificationFilter(filter)) {
        return filter;
      }

      let validValues;

      if (Array.isArray(filter.value)) {
        validValues = validateArrayValues(filter.value, enabledVerificationMethods);
      } else if (filter.value.includes('&')) {
        validValues = validateConcatenatedValues(filter.value, enabledVerificationMethods);
      } else {
        validValues = validateSingleValue(filter.value, enabledVerificationMethods);
      }

      if (validValues === null) {
        return null;
      }

      return {
        ...filter,
        value: validValues
      };
    })
    .filter(filter => filter !== null);
};
